import ApiService from '@/services/core/api.service'

const MailingListService = {
  async get (query) {
    return ApiService.get(`admin/mailing-list?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/mailing-list', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/mailing-list/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`admin/mailing-list/${payload.id}`)
  }
}

export default MailingListService
